import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { TicketThread, TICKET_STATUS } from "@/components/support/TicketThread";

export const SupportAdmin = () => {
  const [tickets, setTickets] = useState([]);
  const [sel, setSel] = useState(null);
  const [text, setText] = useState("");

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/support/tickets");
    setTickets(data);
    setSel((s) => (s ? data.find((t) => t.id === s.id) || null : null));
  }, []);
  useEffect(() => { load(); const iv = setInterval(load, 10000); return () => clearInterval(iv); }, [load]);

  const reply = async () => {
    try {
      await api.post(`/admin/support/tickets/${sel.id}/reply`, { message: text });
      setText(""); toast.success("Cavab göndərildi"); load();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const close = async () => { await api.post(`/admin/support/tickets/${sel.id}/close`); load(); };

  return (
    <div className="grid lg:grid-cols-[360px_1fr] gap-5">
      <div className="rounded-2xl border border-white/10 bg-[#111] divide-y divide-white/5 max-h-[600px] overflow-y-auto" data-testid="admin-ticket-list">
        {tickets.length === 0 && <p className="p-5 text-sm text-zinc-500">Müraciət yoxdur</p>}
        {tickets.map((t) => (
          <button key={t.id} onClick={() => setSel(t)} className={`w-full text-left px-4 py-3 transition-colors hover:bg-white/5 ${sel?.id === t.id ? "bg-white/5" : ""}`} data-testid={`admin-ticket-${t.id}`}>
            <div className="flex justify-between gap-2">
              <p className="font-semibold truncate">{t.subject}</p>
              <span className={`text-[10px] rounded-full px-2 py-0.5 whitespace-nowrap ${TICKET_STATUS[t.status][1]}`}>{TICKET_STATUS[t.status][0]}</span>
            </div>
            <p className="text-xs text-zinc-500 truncate">{t.user_email}</p>
          </button>
        ))}
      </div>
      <div className="rounded-2xl border border-white/10 bg-[#111] p-5">
        {!sel ? <p className="text-zinc-500 text-sm">Müraciət seçin</p> : (
          <div className="space-y-4">
            <div className="flex justify-between items-start gap-3">
              <div><p className="font-display font-bold text-lg">{sel.subject}</p><p className="text-xs text-zinc-500">{sel.user_email}</p></div>
              {sel.status !== "closed" && <button onClick={close} className="btn-ghost rounded-full px-4 py-1.5 text-xs" data-testid="admin-ticket-close-btn">Bağla</button>}
            </div>
            <TicketThread ticket={sel} me="admin" />
            <textarea className="jp-input min-h-[90px]" placeholder="Cavabınızı yazın..." value={text} onChange={(e) => setText(e.target.value)} data-testid="admin-reply-input" />
            <button disabled={!text.trim()} onClick={reply} className="btn-gold rounded-full px-8 py-3 font-display font-bold" data-testid="admin-reply-btn">Cavab göndər</button>
          </div>
        )}
      </div>
    </div>
  );
};
